/**
 * @returns tenant data or empty tenant
 * @action reads tenant from localStorage & returns if present
 * @returns Tenant object | undefined
 */
export const getTenant = () => {
  const tenant = localStorage.getItem("tenantSettings");

  if (tenant) {
    return JSON.parse(tenant);
  }

  return undefined;
};

/**
 * @name removeTenant
 * @returns Void
 * @action removes the Tenant data from localStorage
 */
export const removeTenant = () => localStorage.removeItem("tenantSettings");

/**
 * @name setTenant
 * @param tenant - object as a string
 * @returns Void
 * @action saves the Tenant data to localStorage
 */
export const setTenant = (tenant = "") =>
  localStorage.setItem("tenantSettings", JSON.stringify(tenant));

/**
 * @name setAccessToken
 * @param token - access token string
 * @returns Void
 * @action saves the access token to localStorage
 */
export const setAccessToken = (token = "") =>
  localStorage.setItem("access_token", token);

/**
 * @name getAccessToken
 * @returns String | null
 * @action retrieves the access token from localStorage
 */
export const getAccessToken = () => localStorage.getItem("access_token");

/**
 * @name clearAccessToken
 * @returns Void
 * @action clears the access token from localStorage
 */
export const clearAccessToken = () => localStorage.removeItem("access_token");
